import { TextType } from './TextTypes';

const TEXT_CLASSNAMES: { [key in TextType]: (fromMd?: boolean) => string } = {
  'main-title': (fromMd?: boolean) =>
    fromMd ? 'font-main-title-md' : 'font-main-title',
  'main-title-reg': (fromMd?: boolean) =>
    fromMd ? 'font-main-title-reg-md' : 'font-main-title-reg',
  h1: fromMd => (fromMd ? 'font-h1-md' : 'font-h1'),
  'h1-reg': fromMd => (fromMd ? 'font-h1-reg-md' : 'font-h1-reg'),
  h2: fromMd => (fromMd ? 'font-h2-md' : 'font-h2'),
  'h2-reg': fromMd => (fromMd ? 'font-h2-reg-md' : 'font-h2-reg'),
  h3: fromMd => (fromMd ? 'font-h3-md' : 'font-h3'),
  'h3-reg': fromMd => (fromMd ? 'font-h3-reg-md' : 'font-h3-reg'),
  h4: fromMd => (fromMd ? 'font-h4-md' : 'font-h4'),
  'h4-reg': fromMd => (fromMd ? 'font-h4-reg-md' : 'font-h4-reg'),
  subtitle1: fromMd => (fromMd ? 'font-subtitle1-md' : 'font-subtitle1'),
  subtitle2: fromMd => (fromMd ? 'font-subtitle2-md' : 'font-subtitle2'),
  subtitle3: () => 'font-subtitle3',
  subtitle4: () => 'font-subtitle4',
  body1: fromMd => (fromMd ? 'font-body1-md' : 'font-body1'),
  body2: fromMd => (fromMd ? 'font-body2-md' : 'font-body2'),
  body3: () => 'font-body3',
  body4: () => 'font-body4',
  legals: () => 'font-legals',
  label: () => 'font-label',
  caption: fromMd => (fromMd ? 'font-caption-md' : 'font-caption'),
  button: () => 'font-button',
  link: () => 'font-link',
  currency: fromMd => (fromMd ? 'font-currency-md' : 'font-currency'),
  price: fromMd => (fromMd ? 'font-price-md' : 'font-price'),
  discount: fromMd => (fromMd ? 'font-discount-md' : 'font-discount'),
  'currency-s': fromMd => (fromMd ? 'font-currency-s-md' : 'font-currency-s'),
  'price-s': fromMd => (fromMd ? 'font-price-s-md' : 'font-price-s'),
  'discount-s': fromMd => (fromMd ? 'font-discount-s-md' : 'font-discount-s'),
  'currency-xs': () => 'font-currency-xs',
  'price-xs': () => 'font-price-xs',
  'discount-xs': () => 'font-discount-xs',
};

export default TEXT_CLASSNAMES;
